export default __webpack_public_path__ + "static/media/logo.05bce079.png";